
import {Component, On, Prop, Watch} from 'nuxt-property-decorator';
import ErrorCatcher from '~/components/ErrorCatcher.vue';
import BaseFormComponent from '~/components/Form/BaseFormComponent';
import FormAvatarPicker from '~/components/page-components/FormAvatarPicker.vue';
import SaveOrCancel from '~/components/page-components/SaveOrCancel.vue';
import PrettyContextMenu from '~/components/PrettyContextMenu.vue';
import AvatarEditable from '~/components/misc/AvatarEditable.vue';
import LoadingContext from '~/components/util/LoadingContext.vue';
import {childService} from '~/lib/accessors/api';
import {childGetSingleStore} from '~/lib/accessors/store-accessor';
import ChildView from '~/lib/types/ChildView';
import {EditMode} from '~/lib/types/EditMode';
import {emitToRef} from '~/lib/util/util';


@Component({
  components: {FormAvatarPicker, SaveOrCancel, ErrorCatcher, LoadingContext, PrettyContextMenu, AvatarEditable},
})
export default class ChildAvatarEditable extends BaseFormComponent {
  @Prop({
    type: Object,
    required: true,
  })
  child!: ChildView

  @Prop({
    type: Boolean,
    default: false,
  })
  showEdit!: boolean

  photoFile: File | null = null

  async send() {
    if (!this.doValidate(this.photoFile, 'Wybierz zdjęcie z dysku')) return false;

    // this.editMode = 'not_editing';
    const childRet = await childService
        .withContext(this, {
          // onBeforeThrowError: () => console.error('ERROR'),
          emitErrorsTo: this.$refs.errorCatcher
        })
        .uploadGalleryPhoto(this.child.id, this.photoFile!)

    childGetSingleStore.setChild(childRet);
    this.photoFile = null;

    // this.editMode = 'not_editing';
    return true
  }

  async removePhoto(photo: GalleryPhoto) {
    const childRet = await childService
        .withContext(this, {
          emitErrorsTo: this.$refs.errorCatcher
        })
        .deleteGalleryPhoto(this.child.id, photo.photo_id)

    childGetSingleStore.setChild(childRet);
  }

  @Watch('photoFile')
  watchValue(v: File | null): void {
    if(v) {
      // autosave
      this.submit();
    } else {
      // Clear file input, so we can upload the same file again.
      // TODO: extract <input type="file"> and use it directly.
      this.cancel();
    }
  }

  @On('after_cropped_avatar_photo')
  async onAfterCroppedAvatarPhoto({blob, originalPhotoUrl}: {blob: Blob, originalPhotoUrl: string}) {
    const galleryPhoto = this.child.photoGallery.find(e => e.photo_url === originalPhotoUrl);
    if(galleryPhoto) {
      await this.removePhoto(galleryPhoto);
    }
  }

  cancel() {
    emitToRef(this.$refs.photoPicker, 'clear');
    // this.editMode      = 'not_editing';
    // this.photoFileUrl = this.child.photoUrl;
    this.photoFile = null;
  }

  dummy() {
  }

  get editMode(): EditMode {
    return this.photoFile ? 'editing' : 'not_editing';
  }
}
